var $ = jQuery.noConflict();


function hide_banner(id){
    
    $('#'+id).slideUp("slow");
    
    setCookie(id,'true',30);
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

new WOW().init();



jQuery(document).ready(function(){
	
	//fix loadig js lag
	jQuery('.no-js').removeClass("no-js");
	
	//big carousel
	jQuery('.side-carousel').slick({
		autoplay:true,
		dots:true,
        adaptiveHeight:true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplaySpeed: 2000,
        speed: 1000
  });
    
    var isClickAllowed = true;
    var isDragging = false;
    jQuery('.items-carousel').slick({
        autoplay: true,
        dots: false,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 8,
        swipeToSlide: true,
        //centerMode: true,
        autoplaySpeed: 3000,
        speed: 1000,
        swipe: function(event, slick, direction) {
            jQuery('.items-carousel [data-custom-click]').css('pointer-events', 'none');
            isDragging = true;
            isClickAllowed = false;
        },
        afterChange: function(event, slick, currentSlide) {
            jQuery('.items-carousel [data-custom-click]').css('pointer-events', 'auto');
            setTimeout(function() {
                isDragging = false;
                isClickAllowed = true;
            }, 300); // Imposta il ritardo in millisecondi
        },
        responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 7,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 6,
            }
        },
        {
            breakpoint: 912,
            settings: {
                slidesToShow: 5,
            }
        },
            
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
            }
        }
    ]
        
    });

    // Aggiungi l'evento click sui div con l'attributo data-custom-click
    jQuery('.items-carousel [data-custom-click]').on('click', function(e) {
        if (isDragging || !isClickAllowed) {
            e.preventDefault();
        } else {
            var targetUrl = $(this).data('custom-click');
            window.location.href = targetUrl;
        }
    });
});


function copyStringToClipboard (str) {
   // Create new element
   var el = document.createElement('textarea');
   // Set value (string to be copied)
   el.value = str;
   // Set non-editable to avoid focus and move outside of view
   el.setAttribute('readonly', '');
   el.style = {position: 'absolute', left: '-9999px'};
   document.body.appendChild(el);
   // Select text inside element
   el.select();
   // Copy text to clipboard
   document.execCommand('copy');
   // Remove temporary element
   document.body.removeChild(el);
}